/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { WorkState } from './WorkState';
import {
    WorkStateFromJSON,
    WorkStateFromJSONTyped,
    WorkStateToJSON,
} from './WorkState';

/**
 * 
 * @export
 * @interface UpdateWorkStepDto
 */
export interface UpdateWorkStepDto {
    /**
     * 
     * @type {WorkState}
     * @memberof UpdateWorkStepDto
     */
    workState?: WorkState;
    /**
     * 
     * @type {string}
     * @memberof UpdateWorkStepDto
     */
    $type?: UpdateWorkStepDtoTypeEnum;
}


/**
 * @export
 */
export const UpdateWorkStepDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedJobExecutionDtoUpdateWorkStepDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.JobExecution.Dto.UpdateWorkStepDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type UpdateWorkStepDtoTypeEnum = typeof UpdateWorkStepDtoTypeEnum[keyof typeof UpdateWorkStepDtoTypeEnum];


/**
 * Check if a given object implements the UpdateWorkStepDto interface.
 */
export function instanceOfUpdateWorkStepDto(value?: unknown): value is UpdateWorkStepDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(UpdateWorkStepDtoTypeEnum)[0];
}

export function UpdateWorkStepDtoFromJSON(json: any): UpdateWorkStepDto {
    return UpdateWorkStepDtoFromJSONTyped(json, false);
}

export function UpdateWorkStepDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateWorkStepDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'workState': !exists(json, 'workState') ? undefined : WorkStateFromJSON(json['workState']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function UpdateWorkStepDtoToJSON(value?: UpdateWorkStepDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'workState': WorkStateToJSON(value.workState),
        '$type': value.$type,
    });
}

